import { render, staticRenderFns } from "./StoragePosition.vue?vue&type=template&id=7236ac95"
import script from "./StoragePosition.vue?vue&type=script&lang=js"
export * from "./StoragePosition.vue?vue&type=script&lang=js"
import style0 from "./StoragePosition.vue?vue&type=style&index=0&id=7236ac95&prod&rel=stylesheet%2Fscss&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports